import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarDays, ArrowRight } from 'lucide-react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const NextConsultationStrip = () => {
  const { t } = useTranslation();
  const [slot, setSlot] = useState(null);

  useEffect(() => {
    axios
      .get(`${BACKEND_URL}/api/consultation-slots`)
      .then(({ data }) => setSlot(data[0] || null))
      .catch((error) => console.error('Could not load consultation dates:', error));
  }, []);

  if (!slot) return null;

  const labels = {
    indonesia: t('contact.indonesiaFull'),
    maldives: t('contact.maldives'),
    vietnam: t('contact.vietnam'),
    cyprus: t('contact.northernCyprus')
  };

  return (
    <Link
      to={`/register/${slot.consultation_id}`}
      data-testid="next-consultation-strip"
      className="group block bg-[#102131] border-y border-[#CDA259]/30 hover:bg-[#1a3449] transition-colors duration-300"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-center">
        <span className="inline-flex items-center gap-2 text-[10px] sm:text-xs uppercase tracking-[0.2em] text-[#CDA259]">
          <CalendarDays size={14} />
          {t('contact.nextConsultation')}
        </span>
        <span className="text-sm md:text-base font-semibold text-[#F7FDFF]" data-testid="next-consultation-details">
          {labels[slot.region] || slot.region} · {slot.date} · {slot.time}
        </span>
        <span className="hidden sm:inline text-sm text-[#F7FDFF]/60">{t('contact.onlineConsultation')}</span>
        <span className="inline-flex items-center gap-2 text-sm font-semibold text-[#CDA259] group-hover:gap-3 transition-all duration-200">
          {t('contact.reserve')}
          <ArrowRight size={16} />
        </span>
      </div>
    </Link>
  );
};

export default NextConsultationStrip;
